import React from "react";
import AntSegmented from "antd/es/segmented";
import { TimeRange } from "@shared/types";
import { BASE_CHART_TIME_RANGES } from "@shared/common/constants";

/**
 * The new-look segmented control. The look (pill track, white pill for the
 * selection, 500/600 labels) comes from the shared `.ant-segmented` rules in
 * `styles/newLook.scss`, so every toggle in the app reads as one family.
 */
export const NewLookSegmented = AntSegmented;

interface TimeRangeSegmentsProps {
  selectedTimeRange: TimeRange;
  setTimeRange: (timeRange: TimeRange) => void;
  timeRanges?: TimeRange[];
}

/** The chart time ranges as a compact segmented control. */
export const TimeRangeSegments = ({
  selectedTimeRange,
  setTimeRange,
  timeRanges = BASE_CHART_TIME_RANGES as TimeRange[],
}: TimeRangeSegmentsProps) => (
  <NewLookSegmented<TimeRange>
    size="small"
    value={selectedTimeRange}
    options={timeRanges}
    onChange={(value) => setTimeRange(value)}
  />
);
